import useFetchedData from 'hooks/useFetchedData'
import ProfileItem from 'components/ProfileItem'
import { useNavigate } from 'react-router-dom'
import Loader from 'components/Loader'
import TopBar from 'components/Topbar'
import * as urls from 'api/urls'
import './index.scss'

const MyProfiles: React.FC = () => {
  const { data, isLoading } = useFetchedData<places.PlacesResponse>(urls.places)
  const navigate = useNavigate()

  const filteredMyBoards = (data?.myBoards || []).filter(
    board => board.biography !== null
  )

  return (
    <div className='myProfiles'>
      {isLoading
        ? <Loader type='full' />
        : <div className='savedProfiles'>
          <TopBar isSticky={true} theme='dark' title='Zarządzane pomniki' />
          <div className="savedProfiles__content">
            {filteredMyBoards.length > 0
              ? data?.myBoards.map(board => {
                return (
                  <ProfileItem
                    id={board.id}
                    notification={board.notificationsCount}
                    key={board.id}
                    img={board.img}
                    name={board.name}
                    action={() => navigate(`/manage/${board.id}`)}
                  />
                )
              })
              : <div className='empty' onClick={() => navigate('/addprofile')}>Brak pomników,<br></br>kliknij aby utworzyć</div>
            }
          </div>
        </div>}

    </div>
  )
}

export default MyProfiles